import axios from "axios";
import { Jurisdictions } from "../interfaces/EntityDraftViewModel";
import { getFenXUrl } from "../utils/fenergo-utils";
import URL from "../utils/urls";

let controller;

export async function getAppStatus(): Promise<any> {
    const { data } = await axios.get(
        URL.fenergo.status
    );

    return data;
}

// Lookup Query API  
// TODO: Update the uncommented function to utilize getFenXUrl and update URL.fenergo.getLookups to add "active".
// export async function getLookups() {
//     const { data } = await axios.get(
//         getFenXUrl(URL.fenergo.getLookups)
//     );

//     return data['data'];
// }
export async function getLookups() {
    const { data } = await axios.get(
        '/api/fenergo/' + encodeURIComponent(`lookupquery/api/lookup/active`)
    );

    return data['data'];
}

// Lookup Links Query API  
export async function getLookupLinks() {
    const { data } = await axios.get(
        getFenXUrl(URL.fenergo.getLookupLinks)
    );

    return data['data'];
}

export async function getRequirementsInScope(entityType: string, policyType: string, targetEntity?: string, category?: Array<string>, jurisdictions?: Jurisdictions[]) {
    const jurisdictionNames = jurisdictions.map(jurisdiction => { return { jurisdiction: jurisdiction.jurisdiction } });
    const { data } = await axios.post(
        getFenXUrl(URL.fenergo.getRequirementsInScope),
        {
            data: {
                category,
                entityType,
                targetEntity,
                jurisdictions: jurisdictionNames,
                //type: policyType,
                includeConditions: false
            }
        }
    );

    return data['data'];
}

// Policy Logic Engine
export async function evaluatePolicyEngine(requirementTypes: string[], categories: string[], properties: any, jurisdictions: any, targetEntity?: string) {
    const jurisdictionNames = jurisdictions.map(jurisdiction => { return { jurisdiction: jurisdiction.jurisdiction } });
    const { data } = await axios.post(
        getFenXUrl(URL.fenergo.evaluatePolicyEngine),
        {
            data: {
                requirementTypes,
                categories,
                targetEntity,
                jurisdictions: jurisdictionNames,
                properties,
            }
        }
    );

    return data['data'];
}

// Policy Logic Engine Datagroup
export async function evaluatePolicyEngineDataGroup(dataGroupId, properties) {
    // Return if properties is empty
    if (!properties || Object.values(properties).every(s => !s)) {
        return [];
    }

    const { data } = await axios.post(
        getFenXUrl(URL.fenergo.evaluatePolicyEngineDataGroup),
        {
            data: {
                dataGroupId: dataGroupId,
                data: properties
            }
        }
    );
    return data['data'];
}

// Entity Query API
export async function getEntityDraftData(entityId: string) {
    const { data } = await axios.get(
        getFenXUrl(URL.fenergo.getEntityDraftData(entityId))
    );

    return data['data'];
}

export async function getEntityDraftById(entityId: string, entityDraftId: string) {
    const { data } = await axios.get(
        getFenXUrl(URL.fenergo.getEntityDraftById(entityId, entityDraftId))
    );

    return data['data'];
}

export async function getEntityDraftsList(entityids: string[], journeyId: string) {
    const { data } = await axios.post(
        getFenXUrl(URL.fenergo.getEntityDraftsList),
        { "data": { journeyId, entityids } }
    );

    return data['data'];
}

// Entity Command API
export async function updateEntityDraft(entityId: string, entityDraftId: string, formData: any) {
    const { data } = await axios.put(
        getFenXUrl(URL.fenergo.updateEntityDraft(entityId, entityDraftId)),
        formData.data ? formData : { data: formData }
    );

    return data;
}

// Associations Query API
export async function getAssociations(entityId: string, journeyId: string) {
    const { data } = await axios.get(getFenXUrl(URL.fenergo.getAssociations(entityId, journeyId)));

    return data['data'];
}

// Associations Command API
export async function deleteAssociation(id: string, isVerified: boolean, journeyId: string) {
    await axios.delete(
        getFenXUrl(URL.fenergo.deleteAssociation(id, isVerified, journeyId)));
}

export async function getEntityDocuments(entityId: string) {
    const { data } = await axios.get(
        getFenXUrl(URL.fenergo.getEntityDocuments(entityId))
    );

    return data['data'];
}

export async function getDocumentUrl(documentId: string) {
    const { data } = await axios.get(
        getFenXUrl(URL.fenergo.getDocumentUrl(documentId))
    );

    return data['data'];
}

// Document Management API
export async function uploadDocument(request: any, formData: FormData, setProgress?:any) {
    controller = new AbortController();
    const documentInfo = {
        "data": {
            "fileName": request.fileName,
            "entityId": request.entityId,
            "journeyId": request.journeyId,
            "documentType": request.documentType,
            "friendlyName": request.friendlyName,
            "documentRequirementIds": request.documentRequirementIds,
            "documentDataKey": request.documentDataKey,
            "isDocumentForESignature": false,
            "comesFromESignatureProvider": false,
            "accessLayers": {
                "geographic": [
                    "Global"
                ],
                "businessRelated": [
                    "Enterprise"
                ]
            },
            "policyEnforcedAccessLayers": {
                "geographic": [
                    "Global"
                ],
                "businessRelated": [
                    "Enterprise"
                ]
            }
        }
    }
    formData.append("File.documentInfo", JSON.stringify(documentInfo));
    const { data } = await axios.post(
        URL.fenergo.uploadBasePathV3 + encodeURIComponent(URL.fenergo.uploadDocumentv3),
        formData,
        {  
            headers: { 'Content-Type': request.documentType }, 
            onUploadProgress: (progressEvent) => {
                if (setProgress) setProgress(Math.floor(progressEvent.loaded / progressEvent.total * 100))
            },
        }
    );
    return data;

}

export function cancelUploadDocument() {
    controller.abort();
}

export async function removeDoc(documentId: string) {
    await axios.delete(
        getFenXUrl(URL.fenergo.removeDoc(documentId))
    );
}

// Journey Command API
export async function completeTaskInJourney(journeyInstanceId: string, taskId: string) {
    const { data } = await axios.put(
        getFenXUrl(URL.fenergo.completeTaskInJourney(journeyInstanceId, taskId)),
        { params: { taskId } }
    );

    return data;
}

// Policy Logic Engine
export async function evaluateRequirementsInScope(requirementTypes: string[], categories: string[], entityType: any, jurisdictions: any, targetEntity?: string) {
    const jurisdictionNames = jurisdictions // jurisdictions.map(jurisdiction => { return {jurisdiction: jurisdiction.jurisdiction} });
    const { data } = await axios.post(
        getFenXUrl(URL.fenergo.evaluateRequirementsInScope),
        {
            data: {
                requirementTypes,
                categories,
                targetEntity,
                jurisdictions: jurisdictionNames,
                entityType,
            }
        }
    );

    return data['data'];
}

export async function evaluatePolicyEngineSets(properties: any) {
    const { data } = await axios.post(
        getFenXUrl(URL.fenergo.evaluatePolicyEngineSets),
        {
            data: {
                properties,
            },
        }
    );

    return data["data"];
}

// Policy Logic Engine
export async function evaluatePolicyEngineCapTable(type: string, categories: string[], entityType: string, jurisdictions: string[], targetEntity?: string) {
    //const jurisdictions = jurisdictionsList.map(jurisdiction => { return jurisdiction.jurisdiction });
    const { data } = await axios.post(
        getFenXUrl(URL.fenergo.evaluatePolicyEngineCapTable),
        {
            data: {
                type,
                categories,
                targetEntity,
                jurisdictions,
                entityType,
            }
        }
    );

    return data['data'];
}

